
<div class="header-toolbar">
  <h1>
    Enregistrements
    <span class="tag" *ngIf="filter.search">
      <span class="text">Recherche: {{ filter.search }}</span>
      <t-icon name="close" title="Supprimer ce filtre" (click)="clearSearch()"></t-icon>
    </span>
  </h1>
</div>

<!-- Toolbar -->
<div class="main btn-toolbar">

  <div class="btn-group">    
    <div class="content">
      
      <button class="btn" (click)="applyFilter()">
        <t-icon name="search"></t-icon>
        <span class="text">Filtrer</span>
      </button>

    </div>
  </div>

</div>
<!-- /Toolbar -->

<table>

  <thead>
    <tr>
      <th>Nom</th>
      <th style="width: 320px">Créé par</th>
      <th style="width: 110px">Date d'ajout</th>
    </tr>
  </thead>

  <tbody *ngIf="records && records.length > 0">
    <tr *ngFor="let record of records" (click)="showRecord(record, $event)">
      <td name="Nom">
        {{ record.name }}
      </td>
      <td name="Créée par" style="width: 320px">{{ record.created_by.fullname }}</td>
      <td name="Date d'ajout" style="width: 110px">
        {{ record.created_at | tzdate:'short' }}
      </td>
    </tr>
  </tbody>

  <tbody *ngIf="!records || records.length == 0">
    <tr>
      <td class="text-center" colspan="3">
        <ng-container *ngIf="records && records.length == 0">
          Aucun enregistrement n'a été trouvé
        </ng-container>
        <ng-container *ngIf="!records">
          Chargement...
        </ng-container>
      </td>
    </tr>
  </tbody>

</table>

<div class="pagination" *ngIf="records">
  <button class="btn btn-gray" (click)="fetchMore()" *ngIf="records.length < recordsCount">
    <t-icon name="arrow_downward"></t-icon>
    <span class="text">Afficher plus</span>
  </button>
  <div class="page-number">
    {{ records.length }} / {{ recordsCount }}
  </div>
</div>